import type { StudyFigureGroup, StudyFigureQuestion } from '@digital-twins/shared-types'
import { QuestionFigureView } from '@/features/studies/report/figures/QuestionFigureView'
import { getAppChartPalette } from '@/lib/charts/chartjs'

/** Saved canonical figures use the same renderer in the thread and side panel. */
export function SavedQuestionFigure({ question, baseN, lowBase, onRetry, groups, oneDecimalShares = false }: {
  question: Omit<StudyFigureQuestion, 'metricIds'>
  baseN?: number | null
  lowBase: boolean
  groups?: StudyFigureGroup[]
  onRetry: () => void
  /** Quick Study plots print shares at one decimal; Studies keep whole shares. */
  oneDecimalShares?: boolean
}) {
  return <QuestionFigureView entry={{ status: 'ready', question,
    groups: groups ?? [{ id: 'total', sourceId: null, label: null, kind: 'total', n: baseN ?? 0, lowBase, drawn: true }], notes: [] }}
    controlsPlacement="below" viewport={{ maxHeight: 360 }} visibleDenominator={baseN} isCut={false}
    colors={getAppChartPalette()} onRetry={onRetry} oneDecimalShares={oneDecimalShares} />
}
